module.exports = __webpack_public_path__ + "static/media/user.245e9a5d.png";